var Theme;
(function (Theme) {
  Theme["Behaviour"] = "behaviour";
})(Theme || (Theme = {}));
export const actionToTheme = {
  registration_pop_up: "behaviour",
  generate_success: "behaviour",
  optimize_success: "behaviour",
  image_publish: "behaviour",
  image_download: "behaviour",
  app_visit: "behaviour",
  pic_visit: "behaviour",
  pic_like: "behaviour",
  app_tab: "behaviour",
  sortmode_switch: "behaviour",
  register: "behaviour",
  autologin: "behaviour",
  generate_button_click: "behaviour",
  optimize: "behaviour",
  userpath: "behaviour",
  banner_click: "behaviour",
  build_click: "behaviour",
  build_explore: "behaviour",
  scratch_build_click: "behaviour",
  play_button_click: "behaviour",
  landing_build_click: "behaviour",
  referral_button_click: "behaviour",
  referral_link_success: "behaviour",
  login_button_click: "behaviour",
  share_button_click: "behaviour",
  search: "behaviour",
  save_app: "behaviour",
  fork_app: "behaviour"
};